import "./whatsappOptOut.scss";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PrimaryBtn from "../../../Buttons/PrimaryButton";
import { getCountriesSeed } from "../../../../../redux/actions/authActions";
import { toggleWaMessageOptOut } from "../../../../../redux/actions/shortlinkActions";
import { getFullImageUrl } from "../../../../../utils/constants/constants";
import Input from "../../../TextFields/Input";

const WhatsappOptOut = ({ data }) => {
  const dispatch = useDispatch();
  const [activePage, setActivePage] = useState(0);
  const [countryCode, setCountryCode] = useState("IN");
  const [mobileNumber, setMobileNumber] = useState("");
  const [isSubmitting, setSubmitting] = useState(false);

  const toggleOptOut = (msgTypeArr, activePage) => {
    setSubmitting(true);
    dispatch(
      toggleWaMessageOptOut(data?.entity_id, {
        stop_whatsapp: msgTypeArr,
        campaign_id: data?.campaign_id,
        mobile: {
          number: mobileNumber,
          country_code: countryCode,
        },
      })
    )
      .then(() => {
        setActivePage(activePage);
        setSubmitting(false);
      })
      .catch(() => setSubmitting(false));
  };

  return (
    <div className="whatsapp-opt-out-page">
      <div className="store-details-header">
        {data?.logo && (
          <div className="logo-div">
            <img src={getFullImageUrl(data.logo)} alt="store logo" />
          </div>
        )}
        <h4>{data?.brand_name}</h4>
      </div>
      <div className="unsubscribe-details">
        {activePage === 0 && (
          <UnsubscribeForm
            data={data}
            countryCode={countryCode}
            isSubmitting={isSubmitting}
            toggleOptOut={toggleOptOut}
            mobileNumber={mobileNumber}
            setCountryCode={setCountryCode}
            setMobileNumber={setMobileNumber}
          />
        )}
        {activePage === 1 && (
          <Unsubscribed
            data={data}
            isSubmitting={isSubmitting}
            toggleOptOut={toggleOptOut}
          />
        )}
        {activePage === 2 && <Subscribed data={data} />}
      </div>
    </div>
  );
};

export default WhatsappOptOut;

const UnsubscribeForm = ({
  data,
  countryCode,
  isSubmitting,
  toggleOptOut,
  mobileNumber,
  setCountryCode,
  setMobileNumber,
}) => {
  const dispatch = useDispatch();
  const seedCountries = useSelector((state) => state.auth.countries);

  useEffect(() => {
    dispatch(getCountriesSeed());
  }, [dispatch]);

  return (
    <div className="unsubscribe-form">
      <div className="emoji-img-row">
        <img
          width="32px"
          height="32px"
          alt="thinking_face"
          src="/assets/icons/thinking_face.svg"
        />
        <img
          width="32px"
          height="32px"
          alt="thought_balloon"
          src="/assets/icons/thought_balloon.svg"
        />
      </div>
      <h3>What do you want to do?</h3>
      <p>Enter your number to unsubscribe/subscribe</p>
      <Input
        type="number"
        name="number"
        fullWidth={true}
        isFlagSelect={true}
        label="Mobile Number"
        value={mobileNumber}
        country_code={countryCode}
        seedCountries={seedCountries}
        placeholder="Enter mobile number"
        handleCountrySelect={(val) => setCountryCode(val)}
        handleChange={(e) =>
          e.target.value.length < 14 && setMobileNumber(e.target.value)
        }
      />
      <p>
        If you unsubscibe, you won't recieve any type of new offers on WhatsApp
        from <b>{data?.brand_name}</b>
      </p>
      <PrimaryBtn
        width="100%"
        height="44px"
        btnColor="#eeeeee"
        txtcolor="#1a424f"
        disabled={isSubmitting}
        text="Unsubscribe me"
        handleClick={() => toggleOptOut(["promotional"], 1)}
      />
      <PrimaryBtn
        width="100%"
        height="44px"
        btnColor="#1a424f"
        txtcolor="#ffffff"
        disabled={isSubmitting}
        text="Subscribe me"
        handleClick={() => toggleOptOut([], 2)}
      />
    </div>
  );
};

const Unsubscribed = ({ data, isSubmitting, toggleOptOut }) => {
  return (
    <div className="unsubscribed-success">
      <img
        width="32px"
        height="32px"
        alt="check_mark"
        src="/assets/icons/check_mark.svg"
      />
      <h3>
        From now you won't receive any new offers on Whatsapp from{" "}
        {data?.brand_name}
      </h3>
      <p>
        <b>Change your mind?</b>
      </p>
      <PrimaryBtn
        width="100%"
        height="44px"
        btnColor="#1a424f"
        txtcolor="#ffffff"
        text="Subscribe me"
        disabled={isSubmitting}
        handleClick={() => toggleOptOut([], 2)}
      />
    </div>
  );
};

const Subscribed = ({ data }) => {
  return (
    <div className="subscribed-success">
      <img
        width="32px"
        height="32px"
        alt="partying_face"
        src="/assets/icons/partying_face.svg"
      />
      <h3>
        Awesome!
        <br /> <br /> We will keep you updated on WhatsApp with all exciting
        offers at {data?.brand_name} ✨
      </h3>
      <img
        width="100%"
        alt="subcribed"
        src="/assets/images/shortlinks/subscribed.svg"
      />
    </div>
  );
};
